import HeaderTop from "../components/header/HeaderTop";
import Menu from "../components/menu/Menu";
import Header from "../components/header/Header";
import HomeContent from "../components/home/HomeContent";
import Footer from "../components/footer/Footer";

export default function Home() {
    return (
        <>
            <HeaderTop/>
            <Menu/>
            <Header/>
            <HomeContent/>
            <Footer/>
        </>
    )
}
